import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {TableColumnConfig} from "../../../../model/api/table-column-config";
import {TableRequest} from "../../../../model/api/table-request";
import {TableButtonConfig} from "../../../../model/api/table-button-config";
import {FormFieldGroupConfig} from "../../../../model/api/form-field-group-config";
import {CcTableComponent} from "../../../../crystal-elements/table/cc-table.component";
import {AppConfigService} from "../../../../services/app-config.service";
import {BillingService} from "../../../../services/billing/billing.service";
import {Invoice} from "../../../../model/billing/invoice";
import {InvoiceLoadRequest} from "../../../../model/billing/invoice-load-request";
import {FormFieldConfig} from "../../../../model/api/form-field-config";
import {FieldRecord} from "../../../../model/api/field-record";
import {MoneyOwner} from "../../../../model/customer/money-owner";
import {FieldRequest} from "../../../../model/api/field-request";
import {CommonFieldService} from "../../../../services/common/common-field.service";
import {ReportProfile} from "../../../../model/archive/report-profile";
import {DateTime} from "luxon";
import {InvoiceDetailDialogComponent} from "../../detail/invoice-detail-dialog/invoice-detail-dialog.component";
import {FileUtils} from "../../../../utils/file-utils";
import {ReportTaskService} from "../../../../services/archive/report-task.service";
import {ReportTask} from "../../../../model/archive/report-task";
import {InvoiceProfileService} from "../../../../services/archive/invoice-profile.service";
import {StringUtils} from "../../../../utils/stringUtils";
import {UpdateOutstandingFormComponent} from "./update-outstanding-form/update-outstanding-form.component";
import {CookieService} from "ngx-cookie-service";
import {CookieNames} from "../../../../shared/cookie/cookie-names";
import {ThemeService} from "../../../../services/tools/theme.service";
import {ColorService} from "../../../../services/tools/color-service.service";
import {CcFormComponent} from "../../../../crystal-elements/form-dialog/form/cc-form.component";
import TYPE = FormFieldConfig.TYPE;
import {Owner} from "../../../../model/customer/owner";
import {warn} from "echarts/types/src/util/log";
import {DatePipe} from "@angular/common";
import {ClearingUtils} from "../../../../utils/clearing-utils";
import {CcStorageService} from "../../../../services/common/cc-storage.service";
import {EMPTY, exhaustMap, switchMap, take, takeUntil, timer} from "rxjs";
import {catchError, filter, map, tap} from "rxjs/operators";
import {ApiFileResponse} from "../../../../model/api/api-file-response";

@Component({
  selector: 'app-invoice-list-table',
  templateUrl: './invoice-list-table.component.html',
  styleUrls: ['./invoice-list-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
    DatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceListTableComponent extends CcBaseComponent {

  FieldTypes = FormFieldConfig.TYPE;

  tableConfig: TableColumnConfig[] = [];

  headerButtonConfig: TableButtonConfig[] = [];

  contextMenuConfig: MenuItem[] = [];
  formRecord: Invoice;
  selectedRecords: Invoice[] = [];
  records: Invoice[] = [];
  recordsChange = new EventEmitter<Invoice[]>();

  totalRecords: number = 0;
  inProgressCount: number = 0;

  tableLoading: boolean = true;
  forceReload: boolean = true;

  tableCurrentRequest: InvoiceLoadRequest;
  tableCurrentRequestChange = new EventEmitter<TableRequest>();

  @Input()
  transPartKey: string;
  @Input()
  visible: boolean = true;
  formConfig: FormFieldGroupConfig[];
  @Input()
  detailDialogVisible: boolean = false;
  @Output()
  detailDialogVisibleChange = new EventEmitter<boolean>();

  @ViewChild('ccTable')
  public ccTable: CcTableComponent;

  @ViewChild('invoiceDetailDialog')
  public invoiceDetailDialog: InvoiceDetailDialogComponent;

  formLoading: boolean;
  settingsFormLoadingProgressValue: number = 0;

  owners: FieldRecord<Owner>[] = [];
  moneyOwners: FieldRecord<MoneyOwner>[] = [];
  invoiceStates: FieldRecord<Invoice.InvoiceState>[] = [];

  @ViewChild('ccFormTable')
  ccFormComponent: CcFormComponent;
  @ViewChild('updateOutstandingDialog')
  updateOutstandingDialog: UpdateOutstandingFormComponent;

  protected moneyOwnerColorBkMap = {};
  protected moneyOwnerColorMap = {};

  constructor(cdref: ChangeDetectorRef,
              private confirmationService: ConfirmationService,
              private commonFieldService: CommonFieldService,
              messageService: MessageService,
              private billingService: BillingService,
              private appConfigService: AppConfigService,
              translateService: TranslateService,
              private invoiceProfileService: InvoiceProfileService,
              private reportTaskService: ReportTaskService,
              private storageService: CcStorageService,
              public themeService: ThemeService,
              public colorService: ColorService,
              protected datePipe: DatePipe) {
    super(cdref, messageService, translateService);

  }

  ngOnInit() {
    if (this.storageService.check(CookieNames.BILLING_INVOICE_REQUEST)) {
      // this.tableCurrentRequest = JSON.parse(this.storageService.get(CookieNames.BILLING_INVOICE_REQUEST));
      this.tableCurrentRequest = JSON.parse(this.storageService.get(CookieNames.BILLING_INVOICE_REQUEST), (key, value) => {
        if (key === 'monthEnd' || key === 'monthStart') {
          return new Date(value);
        }
        return value;
      });

      if (this.tableCurrentRequest.monthStartInput && typeof this.tableCurrentRequest.monthStartInput === 'string' && this.tableCurrentRequest.monthStartInput.match(/^\d{4}-\d{2}-\d{2}T/)) {
        this.tableCurrentRequest.monthStartInput = DateTime.fromISO(this.tableCurrentRequest.monthStartInput).toFormat('dd/MM/yyyy');
      }
      if (this.tableCurrentRequest.monthEndInput && typeof this.tableCurrentRequest.monthEndInput === 'string' && this.tableCurrentRequest.monthEndInput.match(/^\d{4}-\d{2}-\d{2}T/)) {
        this.tableCurrentRequest.monthEndInput = DateTime.fromISO(this.tableCurrentRequest.monthEndInput).toFormat('dd/MM/yyyy');
      }
    }
    super.ngOnInit();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
    // setTimeout(() => {
    //   this.reLoadRecords();
    // });
    this.themeService.isDarkThemeChange.subscribe(value => {
      this.moneyOwnerColorBkMap = {};
      this.moneyOwnerColorMap = {};
      this.reLoadRecords();
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  getRowClass(record: Invoice) {
    let className = "";
    if (record.needAttention)
      className = "need-attention ";
    className += "state-" + record.invoiceState.toLowerCase();
    return className;
  }

  getRowDueDateClass(record: Invoice) {
    let classCss = this.getRowClass(record);
    if (record.dueDate && !DateTime.isDateTime(record.dueDate)) {
      record.dueDate = DateTime.fromISO(record.dueDate as any);
    }
    if (record.dueDate && record.dueDate.diff(DateTime.now(), 'days').days < 0)
      classCss += " due-date-passed ";
    return classCss;
  }


  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [

      {
        field: 'id',
        hidden: true,
      },
      // {
      //   width: 30,
      //   field: 'needAttention',
      //   notFilterable: true,
      //   notResizable: true,
      //   class: record => this.getRowClass(record),
      //   icon: record => record.needAttention ? 'fas fa-flag' : '',
      //   mapId: value => '',
      //   style: (record: Invoice) => this.getMoneyOwnerStyle(record)
      // },
      // {
      //   field: 'moneyOwner',
      //   mapId: record => record.moneyOwner + '#_#' + record.customerName
      // },
      {
        field: 'customerNameDisplay',
        class: record => this.getRowClass(record),
        style: (record: Invoice) => this.getMoneyOwnerStyle(record),
        notFilterable: true,
        notSortable: true
      },
      {
        field: 'moneyOwnerDisplay',
        class: record => this.getRowClass(record),
        style: (record: Invoice) => this.getMoneyOwnerStyle(record),
        notFilterable: true,
        notSortable: true
      },
      {
        width: 30,
        type: 'BUTTON',
        notFilterable: true,
        notSortable: true,
        notResizable: true,
        class: value => 'centered ' + this.getRowClass(value),
        icon: value => this.getActionIcon(value),
        toolTip: value => this.getActionTooltip(value),
        command: value => this.doAction(value),
        mapId: value => '',
      },
      {
        field: 'invoiceNumber',
        class: record => this.getRowClass(record),
        mapId: value => {
          if (value.invoiceNumber)
            return value.invoiceNumber + (value.needAttention ? ' <i class="fa-solid fa-flag"></i>' : '');
          return '';
        }
      },
      {
        field: 'contractUnit',
        class: record => this.getRowClass(record),
      },
      {
        field: 'creationDate',
        format: 'dd/MM/yyyy',
        type: 'DATE',
        class: record => this.getRowClass(record),
      },
      {
        field: 'dutyFreeAmount',
        class: record => this.getRowClass(record),
      },
      {
        field: 'vatAmount',
        class: record => this.getRowClass(record),
      },
      {
        field: 'amount',
        class: record => this.getRowClass(record),
      },
      {
        field: 'outStandingAmount',
        class: record => this.getRowClass(record),
      },
      {
        field: 'currency',
        class: record => this.getRowClass(record),
      },
      {
        field: 'invoiceState',
        class: record => this.getRowClass(record) + '-state-column',
        mapId: value => StringUtils.humanize(value.invoiceState),
      },
      {
        field: 'dueDate',
        format: 'dd/MM/yyyy',
        type: 'DATE',
        class: record => this.getRowDueDateClass(record),
      },
      {
        field: 'nbDaysBeforeDueDate',
        notFilterable: true,
        notSortable: true,
        class: record => this.getRowDueDateClass(record),
        mapId: record => {
          let daysCount = 0;
          if (record.dueDate) {
            if (!DateTime.isDateTime(record.dueDate)) {
              record.dueDate = DateTime.fromISO(record.dueDate as any);
            }
            const dueDate = record.dueDate;
            const now = DateTime.now();
            daysCount = Math.round(dueDate.diff(now, 'days').days);
          }
          return daysCount >= 0 ? daysCount + '' : '0';
        },
      },
      // {
      //   field: 'lateDays',
      //   class: record => this.getRowClass(record),
      // },
      // {
      //   field: 'lastRecall',
      //   format: 'dd/MM/yyyy',
      //   type: 'DATE',
      //   class: record => this.getRowClass(record),
      // },
      // {
      //   field: 'settlementDate',
      //   format: 'dd/MM/yyyy',
      //   type: 'DATE',
      //   class: record => this.getRowClass(record),
      // },
      {
        field: 'startingDate',
        format: 'dd/MM/yyyy',
        type: 'DATE',
        class: record => this.getRowClass(record),
      },
      {
        field: 'endDate',
        format: 'dd/MM/yyyy',
        type: 'DATE',
        class: record => this.getRowClass(record),
      },]

    // let simplified = !this.isAdmin();
    // this.headerButtonConfig = [
    //   {
    //     tooltip: this.translateService.instant('common.table.download_button'),
    //     icon: 'fas fa-file-download',
    //     class: ' p-button-success',
    //     command: records => this.download(),
    //     enabled: () => this.selectedRecords && this.hasOneSelection() && Invoice.STATE.TREATED === this.selectedRecords[0].state
    //   }
    // ];
    this.contextMenuConfig = [
      {
        id: 'updateOutstanding',
        label: 'Update Outstanding',
        icon: 'fas fa-hand-holding-dollar',
        command: () => {
          this.onRowDblClick(undefined);
        }
      },
      {
        id: 'showDetails',
        label: 'Show Details',
        icon: 'fas fa-file-lines',
        command: () => {
          this.showDialogForm(this.selectedRecords[0]);
        }
      },
      {
        separator: true,
      },
      {
        id: 'generateInvoice',
        label: 'Generate Invoice',
        icon: 'fas fa-circle-plus',
        command: () => {
          this.doAction(this.selectedRecords[0]);
        }
      },
      {
        id: 'payInvoice',
        label: 'Invoice Paid',
        icon: 'fas fa-credit-card',
        command: () => {
          this.doAction(this.selectedRecords[0]);
        }
      },
      {
        id: 'cancelInvoice',
        label: 'Cancel Invoice',
        icon: 'fas fa-ban',
        command: () => {
          this.doCancelInvoice();
        }
      },
      {
        separator: true,
      },
      {
        id: 'downloadInvoiceExcel',
        label: 'Download Invoice Excel',
        icon: 'fas fa-file-excel',
        command: () => {
          this.doDownloadInvoice(ReportProfile.EXPORT_FORMAT.XLSX);
        }
      },
      {
        id: 'downloadInvoicePdf',
        label: 'Download Invoice PDF',
        icon: 'fas fa-file-pdf',
        command: () => {
          this.doDownloadInvoice(ReportProfile.EXPORT_FORMAT.PDF);
        }
      },
      {
        id: 'emailInvoice',
        label: 'Email Invoice',
        icon: 'fas fa-paper-plane',
        command: () => {
          this.doEmailInvoice(ReportProfile.EXPORT_FORMAT.XLSX);
        }
      },
    ];
    // if (!simplified) {
    //   this.headerButtonConfig.push(
    //     {
    //       tooltip: this.translateService.instant('common.table.detail_button'),
    //       icon: 'fas fa-eye',
    //       class: ' p-button-success',
    //       command: records => this.showDialogForm(this.selectedRecords[0]),
    //       enabled: () => this.selectedRecords && this.hasOneSelection()
    //     });
    //   this.contextMenuConfig.push(
    //     {
    //       label: this.translateService.instant('common.table.detail_button'),
    //       icon: 'fas fa-eye',
    //       command: () => {
    //         this.showDialogForm(this.formRecord);
    //       }
    //     }
    //   );
    // }
    this.formConfig = [{
      group: '',
      fields: [
        {
          field: 'refOwner',
          column: 0,
          type: TYPE.DROPDOWN,
          optionValue: 'text',
          options: () => this.owners,
          hidden: (formRecord1) => this.owners.length <= 1
        },
        {
          field: 'refMoneyOwner',
          column: 0,
          type: TYPE.MULTISELECT,
          options: () => this.moneyOwners
        },
        {
          field: 'states',
          column: 0,
          type: TYPE.MULTISELECT,
          options: () => this.invoiceStates
        },
        {
          column: 0,
          type: TYPE.NONE,
          icon: (id, formRecord1) => 'toolbar-separator fa fa-minus',
          style: record => 'margin-left: 10px;'
        },
        {
          field: 'monthStartInput',
          column: 0,
          type: TYPE.DATE,
          dateView: "month",
          format: "MMM yyyy",
          changed: (value, formRecord1) => {
            if (!this.tableCurrentRequest.monthEndInput
              || DateTime.fromFormat(value, 'dd/MM/yyyy') > DateTime.fromFormat(this.tableCurrentRequest.monthEndInput, 'dd/MM/yyyy')) {
              this.tableCurrentRequest.monthEndInput = this.tableCurrentRequest.monthStartInput;
            }
          }
        },
        {
          field: 'monthEndInput',
          column: 0,
          type: TYPE.DATE,
          dateView: "month",
          format: "MMM yyyy",
          changed: (value, formRecord1) => {
            if (!this.tableCurrentRequest.monthStartInput
              || DateTime.fromFormat(value, 'dd/MM/yyyy') < DateTime.fromFormat(this.tableCurrentRequest.monthStartInput, 'dd/MM/yyyy')) {
              this.tableCurrentRequest.monthStartInput = this.tableCurrentRequest.monthEndInput;
            }
          }
        },
        {
          field: 'filterOnCreateDate',
          column: 0,
          type: TYPE.CHECKBOX,
          useOffLabel: true,
          onIcon: 'fas fa-calendar-plus',
          offIcon: 'fas fa-calendar-check',
          changed: (value, formRecord1) => {
          }
        }]
    }];
  }

  private getMoneyOwnerStyle(record: Invoice) {
    const moneyOwner = record.moneyOwner + '#_#' + record.customerName;
    if (!this.moneyOwnerColorBkMap[moneyOwner]) {
      if (this.themeService.isDarkTheme)
        this.moneyOwnerColorBkMap[moneyOwner] = this.colorService.getColorFromStringDark(moneyOwner);
      else
        this.moneyOwnerColorBkMap[moneyOwner] = this.colorService.getColorFromStringLight(moneyOwner);
    }
    if (!this.moneyOwnerColorMap[moneyOwner]) {
      if (this.themeService.isDarkTheme)
        this.moneyOwnerColorMap[moneyOwner] = this.colorService.getColorFromStringLight(moneyOwner);
      else
        this.moneyOwnerColorMap[moneyOwner] = this.colorService.getColorFromStringDark(moneyOwner);
    }
    return 'background: ' + this.moneyOwnerColorBkMap[moneyOwner] + ' !important; ' +
      'color: ' + this.moneyOwnerColorMap[moneyOwner] + ' !important;';
  }

  protected initData() {
    super.initData();
    this.settingsFormLoadingProgressValue = 0;
    this.commonFieldService.getOwners(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.settingsFormLoadingProgressValue += 100 / 2;
      this.owners = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      if (this.settingsFormLoadingProgressValue >= 100) {
        setTimeout(() => {
          this.reloadFieldValueMap();
          this.reLoadRecords();
        });
      }
    });
    this.commonFieldService.getMoneyOwner(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.settingsFormLoadingProgressValue += 100 / 2;
      this.moneyOwners = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      if (this.settingsFormLoadingProgressValue >= 100) {
        setTimeout(() => {
          this.reloadFieldValueMap();
          this.reLoadRecords();
        });
      }
    });
    this.invoiceStates = [];
    for (const key in Invoice.InvoiceState) {
      this.invoiceStates.push(new FieldRecord(key, StringUtils.humanize(key)));
    }
  }

  reloadFieldValueMap() {
    if (this.ccFormComponent)
      this.ccFormComponent.reloadFieldValueMap();
  }

  reLoadRecords() {
    if (this.destroyed)
      return;
    if (this.tableCurrentRequest) {
      if (this.tableCurrentRequest.monthStartInput)
        this.tableCurrentRequest.monthStart = this.tableCurrentRequest.monthStartInput;
      else
        this.tableCurrentRequest.monthStart = DateTime.now().startOf('month').toFormat('dd/MM/yyyy');
      if (this.tableCurrentRequest.monthEndInput)
        this.tableCurrentRequest.monthEnd = this.tableCurrentRequest.monthEndInput;
      else
        this.tableCurrentRequest.monthEnd = DateTime.now().startOf('month').toFormat('dd/MM/yyyy');
      this.tableLoading = true;

      if (!this.tableCurrentRequest.refOwner && this.owners.length > 0) {
        this.tableCurrentRequest.refOwner = this.owners[0].value.code;
      }
      if (!this.tableCurrentRequest.refOwner) {
        return this.warnMessage("No owner selected");
      }
      this.storageService.set(CookieNames.BILLING_INVOICE_REQUEST, JSON.stringify(this.tableCurrentRequest));
      this.billingService.list(this.tableCurrentRequest).subscribe(tableRecordResult => {
          // console.log("reLoadRecords " + tableRecordResult.total);
          // console.log("----> tableRecordResult " + JSON.stringify(tableRecordResult));
          // console.log("----> total " + tableRecordResult.total+"="+this.totalRecords);
          if (tableRecordResult.success) {
            // if (this.forceReload || this.totalRecords != tableRecordResult.total) {
            this.records = [];
            // this.forceReload = false;
            // }
            this.totalRecords = tableRecordResult.total;
            this.inProgressCount = 0;
            // this.applyRecordResult(tableRecordResult,
            //   this.tableCurrentRequest.first, this.tableCurrentRequest.first + this.tableCurrentRequest.rows);
            // this.records = [...this.records];
            let prevMoneyOwnerPCustomerName = '';
            tableRecordResult.records.forEach(record => {
              if (prevMoneyOwnerPCustomerName !== record.moneyOwner + '#_#' + record.customerName) {
                prevMoneyOwnerPCustomerName = record.moneyOwner + '#_#' + record.customerName;
                record.moneyOwnerDisplay = record.moneyOwner;
                record.customerNameDisplay = record.customerName;
              } else {
                record.moneyOwnerDisplay = '';
                record.customerNameDisplay = '';
              }
            });
            this.records = [...tableRecordResult.records];
            // if(hasChanged){
            //   setTimeout(() => {
            //     this.records = [...this.records];
            //   });
            // }
            // @ts-ignore
            // this.records = tableRecordResult.records ? [...tableRecordResult.records] : [];
            this.recordsChange.emit(this.records);
            this.apiMessage(tableRecordResult);
            this.tableLoading = false;
            this.markForCheck();
          } else {
            this.errorMessage(tableRecordResult.message);
            this.tableLoading = false;
          }
          //refresh
          this.tableCurrentRequest.syncMetadata = tableRecordResult.syncMetadata;
          this.ccTable.reloadTableValueMap();
          // setTimeout(() => {
          //   this.reLoadRecords()
          // }, 30000);
          this.tableLoading = false;
        }
      );
    } else {
      // setTimeout(() => {
      //   this.reLoadRecords()
      // }, 30000);
    }
  }

  // private applyRecordResult(tableRecordResult, from: number, to: number) {
  //   let hasChanged: boolean = false;
  //   tableRecordResult.records.forEach(newRecord => {
  //     const recordIndex = this.records.findIndex(record => record.id === newRecord.id);
  //     if (recordIndex >= 0) {
  //       for (let key in newRecord) {
  //         this.records[recordIndex][key] = newRecord[key];
  //       }
  //     } else {
  //       this.records.splice(0, 0, newRecord);
  //       hasChanged = true;
  //     }
  //   });
  //   return hasChanged;
  // }
  //
  hasOneSelection(): boolean {
    return this.selectedRecords != undefined && this.selectedRecords.length == 1;
  }

  // download(): void {
  //   if (this.selectedRecords) {
  //     this.formRecord = Object.assign({}, this.selectedRecords[0]);
  //   }
  //   if (this.formRecord) {
  //     if (Invoice.STATE.TREATED === this.formRecord.state) {
  //       this.reportTaskService.download(this.formRecord.id).subscribe(apiFileResponse => {
  //         if (apiFileResponse.success) {
  //           FileUtils.download(apiFileResponse);
  //         } else {
  //           this.successMessage(apiFileResponse.message);
  //         }
  //         this.tableLoading = false;
  //       });
  //     } else {
  //       this.infoMessage(this.getTranslation('page.' + this.transPartKey + '.message.not_treated'));
  //     }
  //   }
  // }

  onRowDblClick($event: any) {
    // const currentInvoice = this.selectedRecords[0];
    // if (currentInvoice &&
    //   (currentInvoice.invoiceState === Invoice.InvoiceState.UNPAID
    //     || currentInvoice.invoiceState === Invoice.InvoiceState.ON_HOLD
    //     || currentInvoice.invoiceState === Invoice.InvoiceState.PART_PAID)) {
    // this.invoiceDetailDialog.showDialog(currentInvoice);
    this.updateOutstandingDialog.open(this.selectedRecords[0]);
    // }
  }

  showDialogForm(record: Invoice): void {
    this.invoiceDetailDialog.showDialog(record);
  }

  closeDialogForm()
    :
    void {
    this.detailDialogVisible = false;
    // this.detailDialogVisibleChange.emit(false);
  }

  needLoadRecords(request: InvoiceLoadRequest) {
    this.tableLoading = true;

    if (this.tableCurrentRequest && ((this.tableCurrentRequest.filters.length === 0 && request.filters.length > 0)
      || (JSON.stringify(this.tableCurrentRequest.filters) != JSON.stringify(request.filters))
      || (this.tableCurrentRequest.sortField !== request.sortField)
      || (this.tableCurrentRequest.sortOrder != request.sortOrder)
      || (this.tableCurrentRequest.globalFilter !== request.globalFilter))) {
      // this.totalRecords = 0;
      // this.forceReload = true;
      setTimeout(() => {
        this.reLoadRecords();
      });
    }
    if (request && !this.tableCurrentRequest) {
      this.tableCurrentRequest = request;
      this.tableCurrentRequest.monthStart = DateTime.now().startOf('month').toFormat('dd/MM/yyyy');
      this.tableCurrentRequest.monthEnd = DateTime.now().startOf('month').toFormat('dd/MM/yyyy');
      this.tableCurrentRequest.monthStartInput = DateTime.now().startOf('month').toJSDate();
      this.tableCurrentRequest.monthEndInput = DateTime.now().startOf('month').toJSDate();
      this.tableCurrentRequest.includeUnbilled = true;
      this.tableCurrentRequest.filterOnCreateDate = true;
      this.tableCurrentRequest.states = [Invoice.InvoiceState.UNBILLED, Invoice.InvoiceState.UNPAID, Invoice.InvoiceState.ON_HOLD, Invoice.InvoiceState.PART_PAID];
    } else if (request) {
      this.tableCurrentRequest.sortOrder = request.sortOrder;
      this.tableCurrentRequest.sortField = request.sortField;
      this.tableCurrentRequest.filters = request.filters;
      this.tableCurrentRequest.first = request.first;
      this.tableCurrentRequest.rows = request.rows;
      this.tableCurrentRequest.globalFilter = request.globalFilter;

    }
    if (this.tableCurrentRequest && !this.tableCurrentRequest.sortOrder) {
      this.tableCurrentRequest.sortOrder = -1;
      this.tableCurrentRequest.sortField = 'moneyOwner';
    }
  }

  refreshContextMenu() {
    this.contextMenuConfig.forEach(menu => {
      if (menu.id === 'updateOutstanding') {
        menu.disabled = !this.hasOneSelection()
          || (Invoice.InvoiceState.UNBILLED == this.formRecord.invoiceState);
      } else if (/*menu.id === 'updateOutstanding' ||*/ menu.id === 'cancelInvoice') {
        menu.disabled = !this.hasOneSelection()
          || (this.hasOneSelection() && (Invoice.InvoiceState.CANCELLED == this.formRecord.invoiceState
            || Invoice.InvoiceState.UNBILLED == this.formRecord.invoiceState
            /*|| Invoice.InvoiceState.FULLY_PAID === this.formRecord.invoiceState*/));
      } else if (menu.id === 'generateInvoice') {
        menu.disabled = !this.hasOneSelection()
          || (this.hasOneSelection() && (this.formRecord.invoiceState != Invoice.InvoiceState.UNBILLED));
      } else if (menu.id === 'payInvoice') {
        menu.disabled = !this.hasOneSelection()
          || (this.hasOneSelection() && (this.formRecord.invoiceState != Invoice.InvoiceState.UNPAID
            && this.formRecord.invoiceState != Invoice.InvoiceState.ON_HOLD
            && this.formRecord.invoiceState != Invoice.InvoiceState.PART_PAID));
      } else if (menu.id === 'downloadInvoiceExcel' || menu.id === 'downloadInvoiceExcel' || menu.id === 'downloadInvoicePdf' || menu.id === 'emailInvoice') {
        menu.disabled = !this.hasOneSelection()
          || (this.hasOneSelection() && (Invoice.InvoiceState.UNBILLED === this.formRecord.invoiceState));
      }
    });
    this.contextMenuConfig = [...this.contextMenuConfig];
    this.markForCheck();
  }

  formRecordChanged(formRecord: any) {
    //store record
    // this.storageService.set(this.origin + '_' + CookieNames.ARCHIVE_FORM_RECORD, JSON.stringify(this.formRecord));
    // console.log("---------------> " + JSON.stringify(this.formRecord))
  }

  private getActionIcon(value: Invoice) {
    if (value.invoiceState === Invoice.InvoiceState.UNBILLED)
      return "fas fa-circle-plus";
    else if (value.invoiceState === Invoice.InvoiceState.UNPAID
      || value.invoiceState === Invoice.InvoiceState.ON_HOLD
      || value.invoiceState === Invoice.InvoiceState.PART_PAID)
      return "fas fa-credit-card";
    else
      return "no-icon";
  }

  private getActionTooltip(value: any) {
    if (value.invoiceState === Invoice.InvoiceState.UNBILLED)
      return "Generate Invoice";
    else if (value.invoiceState === Invoice.InvoiceState.UNPAID
      || value.invoiceState === Invoice.InvoiceState.ON_HOLD
      || value.invoiceState === Invoice.InvoiceState.PART_PAID)
      return "Invoice Paid";
    else
      return "";
  }

  private doAction(value: any) {

    let message = "";
    if (value.invoiceState === Invoice.InvoiceState.UNBILLED)
      message = "Confirm Invoice Generation";
    else if (value.invoiceState === Invoice.InvoiceState.UNPAID
      || value.invoiceState === Invoice.InvoiceState.ON_HOLD
      || value.invoiceState === Invoice.InvoiceState.PART_PAID)
      message = "Confirm Invoice Payment";
    else
      return;
    this.confirmationService.confirm({
      header: 'Confirm',
      message: message,
      icon: 'fas fa-exclamation-triangle',
      acceptLabel: 'Yes',
      acceptButtonStyleClass: 'p-button-danger p-button-sm',
      rejectLabel: 'No',
      rejectButtonStyleClass: 'p-button-warning p-button-sm',
      accept: () => {
        if (value.invoiceState === Invoice.InvoiceState.UNBILLED) {
          this.billingService.generateInvoice(value).subscribe(apiValidation => {
            // this.successMessage(apiValidation.message);
            this.reLoadRecords();
          });
        } else if (value.invoiceState === Invoice.InvoiceState.UNPAID
          || value.invoiceState === Invoice.InvoiceState.ON_HOLD
          || value.invoiceState === Invoice.InvoiceState.PART_PAID) {
          this.billingService.payInvoice(value).subscribe(apiValidation => {
            // this.successMessage(apiValidation.message);
            this.reLoadRecords();
          });
        }
      },
      reject: () => {
      }
    });

  }

  private doCancelInvoice() {
    if (this.selectedRecords) {
      this.formRecord = Object.assign({}, this.selectedRecords[0]);
    }
    this.confirmationService.confirm({
      header: 'Confirm',
      message: "Confirm Invoice Cancellation",
      icon: 'fas fa-exclamation-triangle',
      acceptLabel: 'Yes',
      acceptButtonStyleClass: 'p-button-danger p-button-sm',
      rejectLabel: 'No',
      rejectButtonStyleClass: 'p-button-warning p-button-sm',
      accept: () => {
        this.billingService.cancelInvoice(this.formRecord).subscribe(apiValidation => {
          // this.successMessage(apiValidation.message);
          this.reLoadRecords();
        });
      },
      reject: () => {
      }
    });
  }


  doDownloadInvoice(format: ReportProfile.EXPORT_FORMAT) {
    if (this.selectedRecords) {
      this.formRecord = Object.assign({}, this.selectedRecords[0]);
    }
    if (this.formRecord) {
      // const cleanRecord = this.getCleanRecord(this.formRecord.invoiceNumber);
      this.tableLoading = true;
      this.markForCheck();
      this.invoiceProfileService.downloadInvoice({
        format: format,
        invoice: this.formRecord
      })
        .subscribe(apiValidation => {
          this.tableLoading = false;
          this.markForCheck();
          if (apiValidation.success) {
            this.startCheckingReportTask(apiValidation.item);
          } else {
            this.errorMessage(apiValidation.message);
          }
        });
    }
  }

  doEmailInvoice(format: ReportProfile.EXPORT_FORMAT) {
    if (this.selectedRecords) {
      this.formRecord = Object.assign({}, this.selectedRecords[0]);
    }
    if (this.formRecord) {
      this.confirmationService.confirm({
        header: 'Confirm',
        message: "Invoice will send to setup email recipients?",
        icon: 'fas fa-exclamation-triangle',
        acceptLabel: 'Yes',
        acceptButtonStyleClass: 'p-button-success p-button-sm',
        rejectLabel: 'No',
        rejectButtonStyleClass: 'p-button-warning p-button-sm',
        accept: () => {
          // const cleanRecord = this.getCleanRecord(this.formRecord.invoiceNumber);
          this.tableLoading = true;
          this.markForCheck();
          this.invoiceProfileService.emailInvoice({
            format: format,
            invoice: this.formRecord
          })
            .subscribe(apiValidation => {
              this.tableLoading = false;
              this.markForCheck();
              if (!apiValidation.success) {
                this.errorMessage(apiValidation.message);
              }
            });
        },
        reject: () => {
        }
      });
    }
  }


  startCheckingReportTask(taskId: string): void {
    const intervalMs = this.appConfigService.reportCheckInterval;
    const limit = this.appConfigService.reportCheckCallLimit;

    this.tableLoading = true;

    timer(0, intervalMs)
      .pipe(
        takeUntil(this.destroy$),
        take(limit),

        // poll status (no overlap)
        exhaustMap(() =>
          this.reportTaskService.check(taskId).pipe(
            catchError(err => {
              this.errorMessage(String(err));
              this.tableLoading = false;
              this.markForCheck();
              return EMPTY;
            }),
          ),
        ),

        tap(v => {
          if (!v.success) {
            this.errorMessage(v.message);
            this.tableLoading = false;
            this.markForCheck();
          }
        }),
        filter(v => v.success),

        map(v => v.item as ReportTask | null),
        filter((t): t is ReportTask => !!t),

        // stop when terminal (not IN_PROGRESS)
        filter(task => task.state !== ReportTask.STATE.IN_PROGRESS),
        take(1),

        // terminal handling
        switchMap(task => {
          if (task.state === ReportTask.STATE.ERROR) {
            this.infoMessage(task.message);
            this.tableLoading = false;
            this.markForCheck();
            return EMPTY;
          }

          if (task.state !== ReportTask.STATE.TREATED) {
            this.errorMessage(`Report task ${taskId} ended in unexpected state: ${task.state}`);
            this.tableLoading = false;
            this.markForCheck();
            return EMPTY;
          }

          // TREATED -> download
          return this.reportTaskService.download(taskId).pipe(
            catchError(err => {
              this.errorMessage(String(err));
              this.tableLoading = false;
              this.markForCheck();
              return EMPTY;
            }),
          );
        }),

        tap(fileResp => {
          if (!fileResp.success) {
            this.errorMessage(fileResp.message);
            this.tableLoading = false;
            this.markForCheck();
          }
        }),
        filter(fileResp => fileResp.success),
      )
      .subscribe((fileResp: ApiFileResponse) => {
        FileUtils.download(fileResp);
        this.tableLoading = false;
        this.markForCheck();
      });
  }

  invoiceChanged() {
    setTimeout(() => {
      this.reLoadRecords();
    });
  }

}
